import * as React from "react"
import { TimeSpan } from "@figurepos/fgr-lib-business-logic/lib/common/dateTime/hours_of_operation_v2"
import { areAllTimeSpansInactive } from "../utils"

type Props = {
    hooIsActive: boolean
    hooSpans: TimeSpan[]
    message?: string
}
export const HooWarning = ({ hooIsActive, hooSpans, message }: Props) => {
    if (!hooIsActive || !areAllTimeSpansInactive(hooSpans)) {
        return null
    }
    return (
        <div className={classes.wrap}>
            ⚠️ {message || "No hours have been set. Service will appear as closed to customers until hours are added."}
        </div>
    )
}

const classes = {
    wrap: "text-warning text-[13px] inline-block px-3 ml-4 mb-2 relative -top-1 border-warning/50 border rounded-md",
}
